import { nullSafeToString } from '../lib/util';

/**
 * An entry in an {@link Order Order}'s activity log.
 *
 * The storefront log is not the full log. OrderLogEntryV2RestController returns only the non-internal
 * entries visible to the signed-in user, so entries Collaterate staff record against the order for
 * themselves never reach a storefront.
 *
 * @property {number} id - (Read only) This entry's unique id.
 * @property {?Date} createdOn - (Read only) When the entry was written.
 * @property {string} title - (Read only) The entry's title.
 * @property {string} message - (Read only) The entry's body.
 * @property {string} type - (Read only) The entry type.
 * @property {boolean} requiresResolution - (Read only) Whether this entry is waiting on someone to act.
 * @property {boolean} isResolved - (Read only) Whether this entry has been resolved.
 */

class OrderActivityLogEntry {
    constructor (data = {}) {
        this.id = data.id;
        this.createdOn = data.createdOn ? Object.freeze(new Date(data.createdOn)) : null;
        this.title = nullSafeToString(data.title);
        this.message = nullSafeToString(data.message);
        this.type = nullSafeToString(data.orderLogEntryType);
        this.requiresResolution = Boolean(data.requiresResolution);
        this.isResolved = Boolean(data.resolved);

        Object.freeze(this);
    }
}

export default OrderActivityLogEntry;
